import {Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {StepsControllerService} from '../../../services/steps-controller.service';
import {OpstStepOneComponent} from './opst-step-one/opst-step-one.component';
import {UserService} from '../../../services/user.service';
import {AdminService} from '../../../services/admin.service';
import {ViewDocxService} from '../../../services/view-docx.service';
import {PrefixService} from '../../../services/frefix.service';
import {StandardTypesService} from '../../../services/standard-types.service';
import {TreeGroupPosService} from './tree-group-pos-service/tree-group-pos.service';

@Component({
  selector: 'app-create-operating-standard',
  templateUrl: './create-operating-standard.component.html',
  styleUrls: ['./create-operating-standard.component.css']
})
export class CreateOperatingStandardComponent implements OnInit, OnDestroy {
  constructor(private router: Router,
              private modalService: NgbModal,
              public stepsControllerService: StepsControllerService,
              private userService: UserService,
              private adminService: AdminService,
              public viewDocxService: ViewDocxService,
              public prefixService: PrefixService,
              public standardTypesService: StandardTypesService,
              public treeGroupPosService: TreeGroupPosService) {
  }

  ngOnInit() {
    localStorage.setItem('prevRoute', '/dashboard/operating-standards');
    if (this.stepsControllerService.getCurrentStandard() === null) {
      this.stepsControllerService.leaveComponent();
    }
    this.stepsControllerService.setLocalUserLang();
    this.goToActiveRoute();
  }

  goToStep(step) {
    if (this.stepsControllerService.activeStep !== step) {
      this.stepsControllerService.activeStep = step;
      this.goToActiveRoute();
    }
  }

  goToActiveRoute() {
    switch (this.stepsControllerService.activeStep) {
      case 1: {
        // set active step 1 in service
        this.stepsControllerService.activeStep = 1;
        this.router.navigate(['/dashboard/create-operating-standard']);
        break;
      }
      case 2: {
        // set active step 2 in service
        this.stepsControllerService.activeStep = 2;
        this.router.navigate(['/dashboard/create-operating-standard']);
        break;
      }
      case 3: {
        this.router.navigate(['/dashboard/create-operating-standard/step-three']);
        break;
      }
      case 4: {
        this.router.navigate(['/dashboard/create-operating-standard/step-four']);
        break;
      }
      case 5: {
        this.router.navigate(['/dashboard/create-operating-standard/step-five']);
        break;
      }
      case 6: {
        this.router.navigate(['/dashboard/create-operating-standard/step-six']);
        break;
      }
      case 7: {
        this.router.navigate(['/dashboard/create-operating-standard/step-seven']);
        break;
      }
      case 8: {
        this.router.navigate(['/dashboard/create-operating-standard/step-eight']);
        break;
      }
      default: {
        this.router.navigate(['/dashboard/create-operating-standard']);
        break;
      }
    }
  }

  ngOnDestroy() {
    this.stepsControllerService.leaveComponent();
    if (localStorage.getItem('prevRoute').indexOf('/dashboard/create-operating-standard') > -1 && localStorage.getItem('nextRoute').indexOf('/dashboard/operating-standards') === -1) {
      localStorage.removeItem('lastPage');
    }
  }

  goToPrev() {
    if (this.stepsControllerService.activeStep > 1) {
      for (let i = this.stepsControllerService.activeStep; i > 1; i--) {
        if (!this.isEnabledStep((i - 1))) {
          this.stepsControllerService.activeStep = (i - 1);
          this.goToActiveRoute();
          break;
        }
      }

    }
  }

  isEnabledStep(stepNum) {
    switch (stepNum) {
      case 1:
        return this.stepsControllerService.stepOneDisabled;
      case 2:
        return this.stepsControllerService.stepTwoDisabled;
      case 3:
        return this.stepsControllerService.stepThreeDisabled;
      case 4:
        return this.stepsControllerService.stepFourDisabled;
      case 5:
        return this.stepsControllerService.stepFiveDisabled;
      case 6:
        return this.stepsControllerService.stepSixDisabled;
      case 7:
        return this.stepsControllerService.stepSevenDisabled;
      case 8:
        return this.stepsControllerService.stepEightDisabled;
    }
  }

  goToNext() {
    if (this.stepsControllerService.activeStep < 8) {

      // Если создание стандарта кнопкой Next
      if (this.stepsControllerService.activeStep === 2) {
        if (this.stepsControllerService.unlockSThree && !this.stepsControllerService.hasCurrentStandard()) {

          const comp = new OpstStepOneComponent(this.userService,
            this.adminService,
            this.modalService,
            this.viewDocxService,
            this.prefixService,
            this.router,
            this.standardTypesService,
            this.stepsControllerService,
            this.treeGroupPosService);

          comp.qCreateQuest();

        }
      }

      for (let i = this.stepsControllerService.activeStep; i < 7; i++) {
        if (!this.isEnabledStep(i + 1)) {
          this.stepsControllerService.activeStep = (i + 1);
          this.goToActiveRoute();
          break;
        }
      }

    }
  }

  isPrevDisable() {
    let isDiss = true;
    for (let i = this.stepsControllerService.activeStep; i > 1; i--) {
      if (!this.isEnabledStep((i - 1))) {
        isDiss = false;
      }
    }
    return isDiss;
  }

  isNextDisable() {
    let isDiss = true;
    for (let i = this.stepsControllerService.activeStep; i < 7; i++) {
      if (!this.isEnabledStep(i + 1)) {
        isDiss = false;
      }
    }

    if (this.stepsControllerService.activeStep === 2) {
      if (this.stepsControllerService.unlockSThree) {
        isDiss = false;
      }
    }
    return isDiss;
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-operating-standard/create-operating-standard.component.ts